module.exports = __webpack_public_path__ + "static/img/HuangMu_Banner_sumAndautAandWin.e4aeee4b.jpg";